import React, {
	useState,
	useEffect,
} from 'react';

//import Form from 'react-bootstrap/Form'
//import Col from 'react-bootstrap/Col'
//import Row from 'react-bootstrap/Row';
import ListGroup from 'react-bootstrap/ListGroup'
import {
	AiOutlineEdit,
	AiOutlineCloseCircle,
	//AiOutlinePlusCircle,
	//AiFillPlusCircle,
} from 'react-icons/ai';
//import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Button from 'react-bootstrap/Button'


/**
 * This is a custom session list select for the session management
 * - filter by open sessions only or all
 * - filter by a single weigherId
 * - Selection to callback fn instead of setting store sessionId
 *
 * @param {*} props
 */
export const SessionFilteredList = (props) => {

	const {
		//handleFilteredChange,
		handleSessionEditBtn,
		handleSessionCloseBtn,
		sessionIds,
		//msessionId,
		showOpenSessionsOnly,
		weigherId,
		lock,
	} = props;

	const [filteredSessions, setFilteredSessions] = useState([]);

	useEffect(() => {
		const set = sessionIds.filter((session, idx) => {
			if (showOpenSessionsOnly){
				return (session.isOpen && session.Weigher === Number(weigherId))
			} else {
				return (session.Weigher === Number(weigherId))
			}
		})
		setFilteredSessions(set)
	},[showOpenSessionsOnly, weigherId, sessionIds])

	if (filteredSessions.length === 0){
		return (<div className='filteredSessionListNotAvailable'><h6>No sessions available</h6></div>)
	} else {
		//console.log('filteredSessions', filteredSessions)
		return (
			<>
				{/* <p style={{color: 'blue', paddingTop: '0.3em'}}>Click a session to edit!</p> */}
				<ListGroup
					as='ul'
					{ ...(lock && { disabled: true }) }
					className='filteredSessionListUL'
				>
				<ul>
					{ filteredSessions.map((row, idx) =>{
						//console.log('debug', row + ' - ' + idx)
						//console.log('row',row)
						//let active = ((row.SessionID === msessionId))? 'active':'';
						//let css = (row.isOpen)?{ fontWeight: 'bold', width: '100%'}:{ width: '100%'};
						//let statusCss = (row.status === 'open') ? {color: "blue"}:{};
						return (
						<ListGroup.Item
							//as = 'li'
							key = { idx }
							//onClick = { () => handleFilteredChange(row.SessionID) }
							//style = { css }
							className = { row.status === 'open' ? 'openSession' : '' }
						>
									{/* { row.SessionName }{ ((row.isOpen)?' (open)':'') } [id:{row.SessionID}] */}
									<div className="sessionDetails">
										<h6>{ row.SessionName }</h6>{' '}<span className="note">(ID: {row.SessionID})</span>
										<br />
										<p className="sessionStatus">Status: { row.status }</p>
									</div>
									<div className="sessionActions">
										<Button
											size="sm"
											variant="outline-primary"
											disabled = { false }
											onClick = { () => handleSessionEditBtn(row.SessionID) }
											title = {'Edit session'}
										>
											<AiOutlineEdit size={'20'}/>
											Edit
										</Button>
										{' '}
										{row.status !== 'closed' ?
											<Button
												size="sm"
												variant="outline-primary"
												disabled = { false }
												onClick = { () => handleSessionCloseBtn(row.SessionID) }
												title = {'Close session'}
											>
												<AiOutlineCloseCircle size={'20'}/>
												Close
											</Button>
											: ""
										}
									</div>
						</ListGroup.Item>
					)})}
				</ul>
				</ListGroup>
			</>
		)
	}
}